// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"565":"937e043ed6b43efb","651":"a67ffb037c215b07"}[chunkId] + ".js";
};